export enum UpdateSetCardsCraftingConfigurationActionTypes {
  UPDATING_CRAFTING_CONFIGURATION = 'set-cards/UPDATING_CRAFTING_CONFIGURATION',
  CRAFTING_CONFIGURATION_UPDATED = 'set-cards/CRAFTING_CONFIGURATION_UPDATED',
}
